import { render, staticRenderFns } from "./StepCguv.vue?vue&type=template&id=95796642&"
import script from "./StepCguv.vue?vue&type=script&lang=js&"
export * from "./StepCguv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports